/**
        * @fileoverview Generated Streaming Icons
        * @description Auto-generated from streaming-icons.css
        * @generated 2026-01-21T14:22:44.096Z
        */

        /**
         * StreamingIcons enum for consistent icon usage
         */
        export const StreamingIcons = {
          Account: 'account',
  AccountCircle: 'account-circle',
  Add: 'add',
  AdFree: 'ad-free',
  AdFreeSymbol: 'ad-free-symbol',
  Ads: 'ads',
  AdsSymbol: 'ads-symbol',
  Airplay: 'airplay',
  AndroidShare: 'android-share',
  Announcement: 'announcement',
  Apple: 'apple',
  ArrowDown: 'arrow-down',
  ArrowLeft: 'arrow-left',
  ArrowRight: 'arrow-right',
  ArrowUp: 'arrow-up',
  AudienceFreshPopcorn: 'audience-fresh-popcorn',
  AudienceRottenPopcorn: 'audience-rotten-popcorn',
  AudioDescription: 'audio-description',
  Back10sec: 'back-10sec',
  Boost: 'boost',
  Calendar: 'calendar',
  Camera: 'camera',
  Cast: 'cast',
  CastConnected: 'cast-connected',
  CertifiedFresh: 'certified-fresh',
  ChannelsFilled: 'channels-filled',
  ChannelsOutline: 'channels-outline',
  Checkmark: 'checkmark',
  CheckmarkCircleFilled: 'checkmark-circle-filled',
  CheckmarkCircleOutline: 'checkmark-circle-outline',
  ChevronDown: 'chevron-down',
  ChevronLeft: 'chevron-left',
  ChevronRight: 'chevron-right',
  ChevronUp: 'chevron-up',
  Chromecast: 'chromecast',
  ChromecastConnected: 'chromecast-connected',
  Clock: 'clock',
  Close: 'close',
  CloseCricle: 'close-cricle',
  Comedy: 'comedy',
  ContinueWatching: 'continue-watching',
  CreditCard: 'credit-card',
  CriticsFreshTomoato: 'critics-fresh-tomoato',
  Delete: 'delete',
  Device1: 'device-1',
  Device2: 'device-2',
  Device3: 'device-3',
  Device4: 'device-4',
  DolbySound: 'dolby-sound',
  Download: 'download',
  DownloadInProgress: 'download-in-progress',
  DownloadPaused: 'download-paused',
  Drama: 'drama',
  Edit: 'edit',
  Election: 'election',
  Episodes: 'episodes',
  ExitFullscreen: 'exit-fullscreen',
  Expired: 'expired',
  Facebook: 'facebook',
  FastForward: 'fast-forward',
  Fhd: 'fhd',
  ForTheFans: 'for-the-fans',
  FullScreen: 'full-screen',
  Fwd10sec: 'fwd-10sec',
  Hamburger: 'hamburger',
  HayuFilled: 'hayu-filled',
  HayuOutline: 'hayu-outline',
  HbomaxFilled: 'hbomax-filled',
  Hd: 'hd',
  Hide: 'hide',
  HolidayDefault: 'holiday-default',
  HolidaySelected: 'holiday-selected',
  HomeFilled: 'home-filled',
  HomeOutline: 'home-outline',
  HubsFilled: 'hubs-filled',
  HubsOutline: 'hubs-outline',
  Icon4k: '4k',
  Info: 'info',
  InfoFilled: 'info-filled',
  InfoOutline: 'info-outline',
  InMarket: 'in-market',
  Instagram: 'instagram',
  IosShare: 'ios-share',
  Laptop: 'laptop',
  Linkedin: 'linkedin',
  Live: 'live',
  LiveData: 'live-data',
  Lock: 'lock',
  MedalBronze: 'medal-bronze',
  MedalDefault: 'medal-default',
  MedalGold: 'medal-gold',
  MedalSilver: 'medal-silver',
  Mic: 'mic',
  MoreEpisodes: 'more-episodes',
  MoreH: 'more-h',
  MoreV: 'more-v',
  MoviesFilled: 'movies-filled',
  MoviesOutline: 'movies-outline',
  Mute: 'mute',
  NewsFilled: 'news-filled',
  NewsOutline: 'news-outline',
  Next: 'next',
  NextOutline: 'next-outline',
  NotifyMe: 'notify-me',
  OlympicsFilled: 'olympics-filled',
  OlympicsOutline: 'olympics-outline',
  OlympicsRings: 'olympics-rings',
  OutOfMarket: 'out-of-market',
  Paralympics: 'paralympics',
  Pause: 'pause',
  Phone: 'phone',
  PlatformMobile: 'platform-mobile',
  PlatformTvLarge: 'platform-tv-large',
  PlatformTvMedium: 'platform-tv-medium',
  PlatformWeb: 'platform-web',
  Play: 'play',
  Playlist: 'playlist',
  Podium: 'podium',
  Premium: 'premium',
  Previous: 'previous',
  Reality: 'reality',
  Retry: 'retry',
  Rewind: 'rewind',
  Savings: 'savings',
  Search: 'search',
  Settings: 'settings',
  Share: 'share',
  ShoppingHeart: 'shopping-heart',
  Show: 'show',
  SportsBasketballFilled: 'sports-basketball-filled',
  SportsBasketballOutline: 'sports-basketball-outline',
  SportsFilled: 'sports-filled',
  SportsFootballFilled: 'sports-football-filled',
  SportsFootballOutline: 'sports-football-outline',
  SportsOutline: 'sports-outline',
  SportsSoccerFilled: 'sports-soccer-filled',
  SportsSoccerOutline: 'sports-soccer-outline',
  Square: 'square',
  StartFromBeginning: 'start-from-beginning',
  Subtitle: 'subtitle',
  SurroundSound: 'surround-sound',
  Tablet: 'tablet',
  Talent: 'talent',
  ThumbsDown: 'thumbs-down',
  ThumbsDownFilled: 'thumbs-down-filled',
  ThumbsUp: 'thumbs-up',
  ThumbsUpFilled: 'thumbs-up-filled',
  Tiktok: 'tiktok',
  Top10Now: 'top-10-now',
  Top10Peacock: 'top-10-peacock',
  Top10Showmax: 'top-10-showmax',
  Top10Skyshowtime: 'top-10-skyshowtime',
  TriangleDown: 'triangle-down',
  TriangleUp: 'triangle-up',
  Trophy: 'trophy',
  TrueCrime: 'true-crime',
  TvShowsFilled: 'tv-shows-filled',
  TvShowsOutline: 'tv-shows-outline',
  Twitter: 'twitter',
  TwoCard: 'two-card',
  Uhd: 'uhd',
  Unlock: 'unlock',
  UpcomingEvent: 'upcoming-event',
  VerifiedHot: 'verified-hot',
  Volume: 'volume',
  WarningFilled: 'warning-filled',
  WarningOutline: 'warning-outline',
  Waveform: 'waveform',
  WaveformLine: 'waveform-line',
  Wwe: 'wwe',
  X: 'x',
  Youtube: 'youtube'
        };

        /**
         * Array of all available icon names
         */
        export const STREAMING_ICON_NAMES = [
          'account',
  'account-circle',
  'add',
  'ad-free',
  'ad-free-symbol',
  'ads',
  'ads-symbol',
  'airplay',
  'android-share',
  'announcement',
  'apple',
  'arrow-down',
  'arrow-left',
  'arrow-right',
  'arrow-up',
  'audience-fresh-popcorn',
  'audience-rotten-popcorn',
  'audio-description',
  'back-10sec',
  'boost',
  'calendar',
  'camera',
  'cast',
  'cast-connected',
  'certified-fresh',
  'channels-filled',
  'channels-outline',
  'checkmark',
  'checkmark-circle-filled',
  'checkmark-circle-outline',
  'chevron-down',
  'chevron-left',
  'chevron-right',
  'chevron-up',
  'chromecast',
  'chromecast-connected',
  'clock',
  'close',
  'close-cricle',
  'comedy',
  'continue-watching',
  'credit-card',
  'critics-fresh-tomoato',
  'delete',
  'device-1',
  'device-2',
  'device-3',
  'device-4',
  'dolby-sound',
  'download',
  'download-in-progress',
  'download-paused',
  'drama',
  'edit',
  'election',
  'episodes',
  'exit-fullscreen',
  'expired',
  'facebook',
  'fast-forward',
  'fhd',
  'for-the-fans',
  'full-screen',
  'fwd-10sec',
  'hamburger',
  'hayu-filled',
  'hayu-outline',
  'hbomax-filled',
  'hd',
  'hide',
  'holiday-default',
  'holiday-selected',
  'home-filled',
  'home-outline',
  'hubs-filled',
  'hubs-outline',
  '4k',
  'info',
  'info-filled',
  'info-outline',
  'in-market',
  'instagram',
  'ios-share',
  'laptop',
  'linkedin',
  'live',
  'live-data',
  'lock',
  'medal-bronze',
  'medal-default',
  'medal-gold',
  'medal-silver',
  'mic',
  'more-episodes',
  'more-h',
  'more-v',
  'movies-filled',
  'movies-outline',
  'mute',
  'news-filled',
  'news-outline',
  'next',
  'next-outline',
  'notify-me',
  'olympics-filled',
  'olympics-outline',
  'olympics-rings',
  'out-of-market',
  'paralympics',
  'pause',
  'phone',
  'platform-mobile',
  'platform-tv-large',
  'platform-tv-medium',
  'platform-web',
  'play',
  'playlist',
  'podium',
  'premium',
  'previous',
  'reality',
  'retry',
  'rewind',
  'savings',
  'search',
  'settings',
  'share',
  'shopping-heart',
  'show',
  'sports-basketball-filled',
  'sports-basketball-outline',
  'sports-filled',
  'sports-football-filled',
  'sports-football-outline',
  'sports-outline',
  'sports-soccer-filled',
  'sports-soccer-outline',
  'square',
  'start-from-beginning',
  'subtitle',
  'surround-sound',
  'tablet',
  'talent',
  'thumbs-down',
  'thumbs-down-filled',
  'thumbs-up',
  'thumbs-up-filled',
  'tiktok',
  'top-10-now',
  'top-10-peacock',
  'top-10-showmax',
  'top-10-skyshowtime',
  'triangle-down',
  'triangle-up',
  'trophy',
  'true-crime',
  'tv-shows-filled',
  'tv-shows-outline',
  'twitter',
  'two-card',
  'uhd',
  'unlock',
  'upcoming-event',
  'verified-hot',
  'volume',
  'warning-filled',
  'warning-outline',
  'waveform',
  'waveform-line',
  'wwe',
  'x',
  'youtube'
        ];

        /**
         * Check if an icon name is valid
         * @param {string} iconName - Icon name to validate
         * @returns {boolean} True if icon exists
         */
        export const isValidIcon = (iconName) => {
          return STREAMING_ICON_NAMES.includes(iconName);
        };

        export default StreamingIcons;
        